/**
 * History Scroll
 */
export function history_scroll() {
  const sections = document.querySelectorAll('.js-history-scroll');
  if (!sections.length) return;

  sections.forEach((section) => {
    const content = section.querySelector('.history-scroll__panel__inner');
    const bgItems = section.querySelectorAll(
      '.history-scroll__bg-image[data-history-bg]'
    );
    const timelines = section.querySelectorAll(
      '.wp-block-houan-timeline[data-history-bg]'
    );

    if (!content || !bgItems.length || !timelines.length) return;

    let currentBg = '';
    let ticking = false;
    let resizeTimer = null;
    let lastHeight = 0;

    const setSectionHeight = () => {
      const contentHeight = content.offsetHeight;

      const nextHeight = Math.ceil(
        contentHeight
      );

      // 同じ値なら更新しない
      if (lastHeight === nextHeight) return;

      lastHeight = nextHeight;

      section.style.setProperty(
        '--history-scroll-height',
        `${nextHeight}px`
      );
    };

    const updateBackground = () => {
      const center = window.innerHeight * 0.5;

      let activeTimeline = null;
      let minDistance = Infinity;

      timelines.forEach((timeline) => {
        const rect = timeline.getBoundingClientRect();
        const timelineCenter = rect.top + rect.height * 0.5;
        const distance = Math.abs(center - timelineCenter);

        if (distance < minDistance) {
          minDistance = distance;
          activeTimeline = timeline;
        }
      });

      if (!activeTimeline) return;

      const nextBg = activeTimeline.dataset.historyBg;
      if (!nextBg || nextBg === currentBg) return;

      currentBg = nextBg;

      bgItems.forEach((bg) => {
        bg.classList.toggle(
          'is-active',
          bg.dataset.historyBg === nextBg
        );
      });
    };

    const refresh = () => {
      setSectionHeight();
      updateBackground();
    };

    const onScroll = () => {
      if (ticking) return;

      ticking = true;

      requestAnimationFrame(() => {
        updateBackground();
        ticking = false;
      });
    };

    const onResize = () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        refresh();
      }, 120);
    };

    refresh();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    window.addEventListener('load', refresh);
  });
}